<div *ngIf="reviewSourceInfoMap$ | async as reviewSourceInfoMap" class="sources-wrapper">
  <ng-container *ngFor="let sourceId of sortedSelectedSources">
    <div *ngIf="reviewSourceInfoMap[sourceId] as source" class="source-container">
      <div class="source-label">
        <glxy-avatar [src]="source.sourceIconUrl" [width]="20" class="source-icon"></glxy-avatar>
        <span class="source-name">{{ source.sourceName }} </span>
        <span class="listing-name">{{ source.listingName }} </span>
        <span *ngIf="sourceId === '10900' && infoIconForBBB">
          <div [glxyPopover]="popover" (mouseenter)="showPopovers()" (mouseleave)="hidePopovers()">
            <mat-icon class="info-icon">info_outline</mat-icon>
          </div>
          <glxy-popover
            #popover
            [isOpen]="showPopover"
            [maxWidth]="'400px'"
            [positions]="[PopoverPositions.Bottom, PopoverPositions.BottomRight]"
          >
            <div [innerHTML]="'REVIEWS.WIDGET_CONFIG.SOURCES.BBB_INFO_ICON' | translate"></div>
          </glxy-popover>
        </span>
      </div>
    </div>
  </ng-container>
</div>
